import React,{useState,useContext} from 'react';
import UserContext from "../Context/AppContext";
import DrawerMenu from "../Components/DrawerMenu";
import MenuIcon from '@material-ui/icons/Menu';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';
import styled from "styled-components";

const ContainerAppBar=styled.div`
background:#0088FF;
height:min-content;
display:flex;`;

const styles=
{ 
    title:
    {
        margin: "0",
        padding:" 7.5px",
        color: "white",
        textAlign:" center",
        width: "100%",
    },
    Button:
    {
        margin:"10px",
        color:"white",
        cursor:"pointer",
        fontSize:"40px"
    }
}


const HeaderAdmin=({title})=>
{
    const [openMenu, setopenMenu] = useState(false);
    const {user,setUser} = useContext(UserContext);   

    const changeStatusMenu=()=>setopenMenu(!openMenu);

    return (<header>
            <ContainerAppBar>
                <MenuIcon onClick={changeStatusMenu} style={styles.Button}/>
           {user!=="" ? <h1 style={styles.title }>{title}</h1> :  <Typography component="h1"><Skeleton variant="text"/></Typography>}
        </ContainerAppBar>
        <DrawerMenu open={openMenu} close={changeStatusMenu}/>
        </header>);  
}


export default HeaderAdmin;